export interface BenefitsCoverageV2ClientConfig {
  enabled?: boolean;
  titleCoveredBenefits?: string;
  titleNotCoveredBenefits?: string;
}
